import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import styles from './Common.module.css';
import { AlSection, AlModRow } from 'PatientCareCenter/Note/AL';


class AlMod extends React.Component {

    add() {
        this.props.addAlRow(this.props.noteId, 'MLMODALITIES', 'XLMD', 'XLMDNO', 'XLMDXLNO', this.props.xlno, 'NEW_XLMDNO', (this.props.assistVisible && !this.props.isLicensed));
    }

    render() {
        return (
            <AlSection
                id='al_mod'
                name='Modalities'
                timeRequired={false}
                timeVisible={false}
                className={this.props.className}
                onAdd={() => this.add()}
            >
                {this.props.mods.length > 0 &&
                    <div className={styles.row}>
                        <span className={styles.button_spacer} />
                        <span className={styles.col1_header}>Activity</span>
                        <span className={styles.col2_wide_header}>Description</span>
                        <span className={styles.col3_narrow_header}>Time</span>
                        <span className={styles.col4_header}>Performed</span>
                        {this.props.assistVisible &&
                            <span className={styles.col5_header}>Assistant</span>
                        }

                    </div>
                }
                {Object.keys(this.props.mods)
                    .map(key => {
                        const result = this.props.mods[key];
                        return (
                            <AlModRow key={result.XLMDNO} id={result.XLMDNO} />
                        )
                    })
                }
            </AlSection>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addAlRow: bindActionCreators(noteActions.addAlRow, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let assistVisible = state.entities.admissions[epno].contractTracksAssistant;
    let isLicensed = state.entities.authentication.user.islicensed;

    return {
        noteId: noteId,
        xlno: xlno,
        mods: Object.keys(state.entities.notes.MLMODALITIES)
                .filter(key => {
                    return (state.entities.notes.MLMODALITIES[key].XLMDXLNO === xlno)
                })
                .sort((a, b) => state.entities.notes.MLMODALITIES[a].XLMDNO - state.entities.notes.MLMODALITIES[b].XLMDNO)
                .map(key => state.entities.notes.MLMODALITIES[key]),
        assistVisible: assistVisible,
        isLicensed: isLicensed
    };
}

const connectedAlMod = connect(mapStateToProps, mapDispatchToProps)(AlMod);
export { connectedAlMod as AlMod };

